import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const LivePointIcon = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "currentColor",
    width: size || '14',
    height: size || '14'
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: "0",
    y: "0",
    width: "12",
    height: "12",
    rx: "6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    fill: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02---Thumbnail-Components",
    transform: "translate(-1376 -7463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(1377 7464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-9",
    opacity: ".4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    x: "-.45",
    y: "-.45",
    width: "12.9",
    height: "12.9",
    rx: "6.45",
    strokeWidth: ".9"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-9",
    fill: "currentColor",
    x: "3",
    y: "3",
    width: "6",
    height: "6",
    rx: "3"
  })))));
};
LivePointIcon.displayName = 'LivePointIcon';
export default LivePointIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=LivePointIcon.js.map